"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.tr_searchDepartmentToggle = exports.tr_searchClick = exports.tr_searchEvent = void 0;
const analytics4Tracking_1 = require("@ocm/services/analytics4Tracking");
const dataLayer_1 = __importDefault(require("@ocm/services/dataLayer"));
const tr_searchEvent = (payload) => {
    (0, analytics4Tracking_1.pushGA4CustomEvent)("search", payload);
};
exports.tr_searchEvent = tr_searchEvent;
const tr_searchClick = (target) => {
    (0, dataLayer_1.default)({
        event: "GAevent",
        event_category: "S_1stlevel",
        event_action: `S_${target} Desktop Search`,
    });
};
exports.tr_searchClick = tr_searchClick;
const tr_searchDepartmentToggle = (payload) => {
    (0, analytics4Tracking_1.pushGA4CustomEvent)("search", payload);
};
exports.tr_searchDepartmentToggle = tr_searchDepartmentToggle;
